import type { TagDesignTokens } from '@primeuix/themes/types/tag';

 export default {
    icon: {
        size: "0.75rem"
    },
    root: {
        gap: "0.25rem",
        padding: "0.25rem 0.5rem",
        fontSize: "0.875rem",
        fontWeight: "{font.weight.bold}",
        borderRadius: "{border.radius.sm}",
        roundedBorderRadius: "{border.radius.round}"
    },
    colorScheme: {
        dark: {
            info: {
                color: "{blue.300}",
                background: "color-mix(in srgb, {blue.500}, transparent 84%)"
            },
            warn: {
                color: "{gold.300}",
                background: "color-mix(in srgb, {gold.500}, transparent 84%)"
            },
            danger: {
                color: "{red.300}",
                background: "color-mix(in srgb, {red.500}, transparent 84%)"
            },
            primary: {
                color: "{primary.300}",
                background: "color-mix(in srgb, {primary.500}, transparent 84%)"
            },
            success: {
                color: "{green.300}",
                background: "color-mix(in srgb, {green.500}, transparent 84%)"
            },
            contrast: {
                color: "{surface.950}",
                background: "{surface.0}"
            },
            secondary: {
                color: "{surface.300}",
                background: "{surface.800}"
            }
        },
        light: {
            info: {
                color: "{brand.800}",
                background: "{brand.100}"
            },
            warn: {
                color: "{gold.700}",
                background: "{gold.100}"
            },
            danger: {
                color: "{red.700}",
                background: "{red.100}"
            },
            primary: {
                color: "{primary.700}",
                background: "{primary.100}"
            },
            success: {
                color: "{green.800}",
                background: "{green.100}"
            },
            contrast: {
                color: "{surface.0}",
                background: "{surface.950}"
            },
            secondary: {
                color: "{surface.700}",
                background: "{surface.100}"
            }
        }
    }
} satisfies TagDesignTokens;